import React, { useState } from 'react';
import Hero from '../components/Hero';
import TrustStrip from '../components/TrustStrip';
import Services from '../components/Services';
import Section from '../components/Section';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import MobileCallButton from '../components/MobileCallButton';
import ReviewDialog from '../components/ReviewDialog';
import ImagesProvider from '../contexts/ImagesProvider';

// Review data comes from the FeedbacksProvider in App.js.
export default function HomePage() {
  const [reviewOpen, setReviewOpen] = useState(false);
  const openReview = () => setReviewOpen(true);

  return (
    <>
      <Hero />
      <main>
        <TrustStrip />
        <Services />
        <Section
          id="gallery"
          eyebrow="Our work"
          title="Recent projects"
          subtitle="A look at some of the yards, lawns and surfaces we've worked on. Tap any photo to see it full size."
        >
          <ImagesProvider>
            <Gallery />
          </ImagesProvider>
        </Section>
        <Testimonials onLeaveReview={openReview} />
        <ContactSection />
      </main>
      <Footer onLeaveReview={openReview} />
      <MobileCallButton />
      <ReviewDialog open={reviewOpen} onClose={() => setReviewOpen(false)} />
    </>
  );
}
